import { isLegacyBilling } from './billingVersion'

const DEFAULT_DESK_URL = 'https://desk.botpress.cloud'
const DESK_REDIRECT_NEW_WORKSPACE_CUTOFF = new Date('2026-05-07T00:00:00Z').getTime()

export const isDeskRedirectEligible = (workspace: { billingVersion: string; createdAt: string }): boolean => {
  const isNewWorkspace = new Date(workspace.createdAt).getTime() >= DESK_REDIRECT_NEW_WORKSPACE_CUTOFF
  return !isLegacyBilling(workspace) || isNewWorkspace
}

export const getDeskRedirectUrl = ({
  baseUrl,
  workspaceId,
  redirect,
}: {
  baseUrl?: string
  workspaceId: string
  redirect?: string
}): string => {
  const params = new URLSearchParams({ welcome: '1', workspaceId })
  if (redirect) {
    params.set('redirect', redirect)
  }
  return `${(baseUrl ?? DEFAULT_DESK_URL).replace(/\/$/, '')}/?${params.toString()}`
}
